import { Injectable, Injector } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { SecurityService } from "../services/securityService";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private securityService: SecurityService | null = null;

  constructor(private injector: Injector) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    // Lazy load SecurityService to avoid circular dependency
    if (!this.securityService) {
      this.securityService = this.injector.get(SecurityService);
    }

    var accessToken = this.securityService.getToken();
    if (accessToken) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
    }
    return next.handle(request);
  }
}
